import React from 'react';

const FormColor = React.forwardRef(({label, value = '999900', setValue, error, placeholder = '', maxLength}, ref) => {
	if (placeholder === '') {
		placeholder = label;
	}

	if (!maxLength) {
		maxLength = 100;
	}

	const showMeta = label !== '' || error !== '';

	return (
		<div className={`input-div${error !== '' ? ' has-error' : ''}`}>
			{showMeta ? (
				<div className="input-meta">
					<div className="input-meta-left">
						{label !== '' ? <div className="input-label">{label}</div> : ''}
					</div>
					{error !== '' ? <div className="input-error">{error}</div> : ''}
				</div>
			) : ''}
			<div className="input-control">
				<input className="input-text color" type="color" placeholder={placeholder} ref={ref} value={value} onChange={(e) => setValue(e.target.value)} />
			</div>
		</div>
	);
});

export default FormColor;
